var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mic-on_svg__clip0_145_1366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.114 4.781a2.667 2.667 0 014.553 1.886V12a2.667 2.667 0 01-5.334 0V6.667c0-.707.281-1.386.781-1.886zM12 5.334a1.333 1.333 0 00-1.333 1.333v.683h.833a.65.65 0 110 1.3h-.833v1.7h.833a.65.65 0 110 1.3h-.833V12a1.334 1.334 0 002.666 0V6.667A1.333 1.333 0 0012 5.334zM7.333 10c.368 0 .667.299.667.667V12a4 4 0 008 0v-1.333a.667.667 0 011.333 0V12a5.333 5.333 0 01-4.666 5.292v2.042a.667.667 0 01-1.334 0v-2.042A5.333 5.333 0 016.666 12v-1.333c0-.368.299-.667.667-.667z",
    fill: "#231A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mic-on_svg__clip0_145_1366"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgMicOn;